import { Ref } from 'react';

import cn from 'utils/cn';

import Level from './level';

import './index.css';

export interface ILevelProps {
    key?: string | number;
    innerRef?: Ref<HTMLDivElement>;
    className?: string;
}

export const b = cn('level');

export default Level;
